(function () {
  const CONFIG_SELECTOR = '[data-free-gift], [data-pdp-gifts]';
  const FORM_SELECTOR = 'form[data-type="add-to-cart-form"]';
  const ATTACHED_ATTR = 'data-free-gift-attached';

  function getCartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function getAtcBehavior(form) {
    const productForm =
      (form && form.closest('ctr-product-form, product-form')) ||
      document.querySelector('ctr-product-form, product-form');
    return (productForm && productForm.dataset.atcBehavior) || 'cart_drawer';
  }

  function getProductRoot(element) {
    return (
      element.closest('product-info') ||
      element.closest('.product') ||
      element.closest('.shopify-section') ||
      document
    );
  }

  function getForm(config) {
    const root = getProductRoot(config);
    return root.querySelector(FORM_SELECTOR) || document.querySelector(FORM_SELECTOR);
  }

  function getSubmitButton(form) {
    return form.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"]');
  }

  function getFormProperties(form) {
    const properties = {};
    const propertyInputs = form.querySelectorAll('[name^="properties["]');

    for (const input of propertyInputs) {
      if (input.disabled || !input.name) continue;

      const checkboxOrRadio = input.type === 'checkbox' || input.type === 'radio';
      if (checkboxOrRadio && !input.checked) continue;

      const key = input.name.replace(/^properties\[/, '').replace(/\]$/, '');
      if (!key) continue;

      properties[key] = input.value;
    }

    return properties;
  }

  function shouldApplyGift(config, sellingPlan, forceOtp) {
    const appliesTo = config.dataset.appliesTo || 'both';

    if (appliesTo === 'subscription_only') return Boolean(sellingPlan) && !forceOtp;
    if (appliesTo === 'otp_only') return !sellingPlan || forceOtp;

    return true;
  }

  function isConfigEnabled(config) {
    if (!config.hasAttribute('data-pdp-gifts')) return true;
    return config.dataset.giftsEnabled !== 'false';
  }

  function getGiftVariantIds(config) {
    if (config.dataset.giftVariantIds) {
      try {
        const parsed = JSON.parse(config.dataset.giftVariantIds);
        if (!Array.isArray(parsed)) return [];

        return parsed
          .map((id) => String(id).trim())
          .filter((id) => id.length > 0);
      } catch (error) {
        console.error('Invalid gift variant IDs JSON:', error);
        return [];
      }
    }

    const singleGiftVariantId = config.dataset.giftVariantId || '';
    return singleGiftVariantId ? [singleGiftVariantId] : [];
  }

  function appendGiftItems(formData, giftVariantIds, mainVariantId, propertyKey, propertyValue, shippingOffer) {
    giftVariantIds.forEach((giftVariantId, index) => {
      const itemIndex = index + 1;

      formData.append(`items[${itemIndex}][id]`, giftVariantId);
      formData.append(`items[${itemIndex}][quantity]`, '1');
      formData.append(`items[${itemIndex}][parent_id]`, mainVariantId);
      formData.append(`items[${itemIndex}][properties][${propertyKey}]`, propertyValue);
      formData.append(`items[${itemIndex}][properties][_shipping_offer]`, shippingOffer);
    });
  }

  function buildFormData(config, form, forceOtp) {
    const variantInput = form.querySelector('input[name="id"]');
    const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
    const quantityInput = form.querySelector('[name="quantity"]');
    const mainVariantId = variantInput ? variantInput.value : '';
    const sellingPlan = forceOtp ? '' : (sellingPlanInput ? sellingPlanInput.value : '');
    const giftVariantIds = getGiftVariantIds(config);
    const propertyKey = config.dataset.propertyKey || '_offer';
    const propertyValue = config.dataset.propertyValue || 'Free Gift';
    const shippingOffer = config.dataset.shippingOffer || 'paid';
    const quantity = quantityInput && quantityInput.value ? quantityInput.value : '1';

    if (!mainVariantId || giftVariantIds.length === 0) return null;
    if (!isConfigEnabled(config)) return null;
    if (!shouldApplyGift(config, sellingPlan, forceOtp)) return null;

    const formData = new FormData();
    formData.append('items[0][id]', mainVariantId);
    formData.append('items[0][quantity]', quantity);

    if (sellingPlan) {
      formData.append('items[0][selling_plan]', sellingPlan);
    }

    const mainProperties = getFormProperties(form);
    for (const key in mainProperties) {
      formData.append(`items[0][properties][${key}]`, mainProperties[key]);
    }

    if (!Object.prototype.hasOwnProperty.call(mainProperties, '_shipping_offer')) {
      formData.append('items[0][properties][_shipping_offer]', shippingOffer);
    }

    appendGiftItems(formData, giftVariantIds, mainVariantId, propertyKey, propertyValue, shippingOffer);

    return formData;
  }

  function appendCartSections(formData, cart) {
    if (!cart || !cart.getSectionsToRender) return;

    formData.append(
      'sections',
      cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    cart.setActiveElement(document.activeElement);
  }

  function setLoading(button, isLoading) {
    if (!button) return;

    if (isLoading) {
      button.setAttribute('aria-disabled', true);
      button.classList.add('loading');
    } else {
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
    }

    const spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }

  function publishCartUpdate(source, productVariantId, response) {
    if (typeof publish === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

    publish(PUB_SUB_EVENTS.cartUpdate, {
      source,
      productVariantId,
      cartData: response,
    });
  }

  function publishCartError(source, productVariantId, response) {
    if (typeof publish === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

    publish(PUB_SUB_EVENTS.cartError, {
      source,
      productVariantId,
      errors: response.errors || response.description,
      message: response.message,
    });
  }

  function renderCart(cart, response, atcBehavior, discountCode) {
    if (atcBehavior === 'direct_checkout') {
      if (typeof window.ctrGoToCheckout === 'function') {
        window.ctrGoToCheckout(discountCode);
      } else {
        window.location.href = '/checkout';
      }
      return;
    }

    if (!cart) {
      window.location = window.routes ? window.routes.cart_url : '/cart';
      return;
    }

    if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');

    if (typeof CartPerformance !== 'undefined') {
      CartPerformance.measure('add:paint-updated-sections', () => {
        cart.renderContents(response);
      });
      return;
    }

    cart.renderContents(response);
  }

  function buildMainProductFormData(form, forceOtp) {
    const formData = new FormData(form);

    if (forceOtp) {
      formData.delete('selling_plan');
    }

    return formData;
  }

  function getDiscountCode(config, form, forceOtp) {
    const otpCode = (
      (config && config.dataset.otpDiscountCode) ||
      (form && form.closest('[data-otp-discount-code]') && form.closest('[data-otp-discount-code]').dataset.otpDiscountCode) ||
      ''
    ).trim();
    const subCode = (
      (config && config.dataset.discountCode) ||
      (form && form.closest('[data-discount-code]') && form.closest('[data-discount-code]').dataset.discountCode) ||
      ''
    ).trim();

    if (forceOtp && otpCode) return otpCode;

    const sellingPlanInput = form ? form.querySelector('[name="selling_plan"]') : null;
    const sellingPlan =
      !forceOtp && sellingPlanInput && !sellingPlanInput.disabled
        ? String(sellingPlanInput.value || '').trim()
        : '';

    if (!sellingPlan && otpCode) return otpCode;
    return subCode || otpCode;
  }

  async function postCartAdd(formData, button, source, atcBehavior, discountCode) {
    const cart = getCartElement();
    if (atcBehavior === 'direct_checkout' && typeof window.ctrBeginDirectCheckout === 'function') {
      try {
        await window.ctrBeginDirectCheckout();
      } catch (e) {}
    }
    appendCartSections(formData, cart);

    const configFetch = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
    configFetch.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete configFetch.headers['Content-Type'];
    configFetch.body = formData;

    setLoading(button, true);

    try {
      const response = await fetch(`${routes.cart_add_url}`, configFetch);
      const parsedResponse = await response.json();

      if (parsedResponse.status) {
        publishCartError(source, formData.get('id') || formData.get('items[0][id]'), parsedResponse);
        return false;
      }

      if (discountCode && typeof window.ctrApplyDiscountCode === 'function') {
        await window.ctrApplyDiscountCode(discountCode);
      }

      if (atcBehavior !== 'direct_checkout') {
        publishCartUpdate(source, formData.get('id') || formData.get('items[0][id]'), parsedResponse);
      }
      renderCart(cart, parsedResponse, atcBehavior, discountCode);

      return true;
    } catch (error) {
      console.error(`${source} add to cart failed:`, error);
      return false;
    } finally {
      setLoading(button, false);
    }
  }

  function addMainProduct(form, button, forceOtp, config) {
    return postCartAdd(
      buildMainProductFormData(form, forceOtp),
      button,
      'ctr-free-gift-fallback',
      getAtcBehavior(form),
      getDiscountCode(config, form, forceOtp)
    );
  }

  async function addItems(formData, button, form, config, forceOtp) {
    return postCartAdd(
      formData,
      button,
      'ctr-free-gift',
      getAtcBehavior(form),
      getDiscountCode(config, form, forceOtp)
    );
  }

  function attachSubmitHandler(config, form) {
    form.addEventListener(
      'submit',
      async (event) => {
        const formData = buildFormData(config, form, false);
        if (!formData) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const button = getSubmitButton(form);
        const addedWithGift = await addItems(formData, button, form, config, false);
        if (!addedWithGift) await addMainProduct(form, button, false, config);
      },
      true
    );
  }

  function attachBuyOnceHandlers(config, form) {
    const root = getProductRoot(config);
    const buyOnceButtons = root.querySelectorAll('[data-ctr-buy-once], [data-buy-once]');

    for (const button of buyOnceButtons) {
      if (button.hasAttribute(ATTACHED_ATTR)) continue;
      button.setAttribute(ATTACHED_ATTR, 'true');

      button.addEventListener(
        'click',
        async (event) => {
          const formData = buildFormData(config, form, true);
          if (!formData) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          const addedWithGift = await addItems(formData, button, form, config, true);
          if (!addedWithGift) await addMainProduct(form, button, true, config);
        },
        true
      );
    }
  }

  function init() {
    const configs = document.querySelectorAll(CONFIG_SELECTOR);

    for (const config of configs) {
      if (config.hasAttribute(ATTACHED_ATTR)) continue;

      const form = getForm(config);
      if (!form) continue;

      config.setAttribute(ATTACHED_ATTR, 'true');
      attachSubmitHandler(config, form);
      attachBuyOnceHandlers(config, form);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
